<emma-modal (close)="close.emit()" size="lg" [noFooter]="false">
    <ng-container class="emma-modal-title">
        <i *ngIf="icon" class="la la-{{ icon }}" aria-hidden="true"></i>
        <span>{{ headTitle }}</span>
    </ng-container>
    <ng-container class="emma-modal-body">
        <div *ngIf="message" class="row">
            <div class="col-md-12">
                {{ message }}
            </div>
        </div>
        <div *ngIf="messageHtml && !message" class="row">
          <div class="col-md-12" [innerHTML]="messageHtml"> >
          </div>
      </div>
    </ng-container>
    <ng-container class="emma-modal-footer">
        <button emmaButton [color]="cancelColor" (click)="cancel.emit()">
            {{ cancelText }}
        </button>
        <button emmaButton [color]="confirmColor" [isWide]="true" (click)="confirm.emit()">
            {{ confirmText }}
        </button>
    </ng-container>
</emma-modal>
